import { EventEmitter } from 'events';
import { StylingProviderEvents } from '@fluidx/office-fluid-types';
/**
 * Default implementation of both the @StylingProvider interface and @Theming contract to be used by hosts.
 */
export class AppStylingProvider extends EventEmitter {
    constructor() {
        super();
        this.setMaxListeners(0);
    }
    get Theming() {
        return this;
    }
    get themingName() {
        return this._themeName;
    }
    get themingProperties() {
        return this._themeProperties;
    }
    /** Will fire 'themeNameChanged' on change of themeName */
    set themingName(name) {
        if (name === this._themeName) {
            return;
        }
        this._themeName = name;
        this.emit('themeNameChanged');
    }
    /** Will fire 'themePropertiesChanged' on change of themeProperties */
    set themingProperties(properties) {
        this._themeProperties = properties;
        this.emit('themePropertiesChanged');
    }
    get StylingProvider() {
        return this;
    }
    get themeProperties() {
        return this.appThemeProperties;
    }
    get textStyles() {
        return this.appTextStyles;
    }
    /** Will fire 'themePropertiesChanged' on change of themeProperties */
    setThemeProperties(properties) {
        const previousThemeProperties = this.appThemeProperties ? new Map(this.appThemeProperties) : undefined;
        this.appThemeProperties = properties;
        this.emit(StylingProviderEvents.themePropertiesChanged, previousThemeProperties);
    }
    /* Will fire 'textStylesChanged' on change of textStyles */
    setTextStyles(styles) {
        const previousStyles = this.appTextStyles ? new Map(this.appTextStyles) : undefined;
        this.appTextStyles = styles;
        this.emit(StylingProviderEvents.textStylesChanged, previousStyles);
    }
}
//# sourceMappingURL=AppStylingProvider.js.map